import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import locationService from "../Services/locationService";
import warehouseService from "../Services/warehouseService";
import Dropdown from "../Components/Dropdown";
import SecondaryButton from "../Components/SecondaryButton";
import { FiPlus } from "react-icons/fi";

const AddLocation = ({ edit = false }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [warehouses, setWarehouses] = useState([]);

  const [data, setData] = useState({
    name: "",
    number: "",
    type: "",
    area: "",
    description: "",
    warehouse: "",
  });

  const [errors, setErrors] = useState({
    name: false,
    number: false,
    type: false,
    area: false,
    description: false,
    warehouse: false,
  });
  const [regex, setRegex] = useState({
    name: /.{1,50}$/,
    number: /.{1,50}$/,
    type: /.{1,50}$/,
    area: /.{1,50}$/,
    description: /.{1,50}$/,
    warehouse: /.{1,50}$/,
  });

  useEffect(() => {
    const getWarehouses = async () => {
      const response = await warehouseService.fetchAll();
      console.log(response);
      setWarehouses(response.warehouses);
    };
    getWarehouses();
  }, []);

  // useEffect(() => {
  //     if (edit) {
  //         if (params.get("id")) {
  //             roleService.getSingle(params.get("id")).then((res) => {
  //                 setData(d => ({ ...d, name: res.role.name }))
  //                 setID(res.role.id)
  //             })
  //         }
  //     }
  // },[])

  const handleChange = (e) => {
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));
    setErrors((errs) => ({ ...errs, [e.target.name]: false }));
  };

  const handleSubmit = () => {
    setLoading(true);
    let hasError = false;
    Object.keys(data).map((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        console.log(v);
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill all the required fields");
      setLoading(false);
    } else {
      if (!edit) {
        locationService.createLocation(data).then((res) => {
          navigate("/location");
          setLoading(false);
        });
      } else {
        // warehouseService.update(ID, data).then(res => {
        //     navigate("/warehouse")
        //     setLoading(false)
        // })
      }
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <h1 className="font-bold text-center text-3xl text-secondary mt-10">
        Add Location
      </h1>
      <div className="mt-10 px-80">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8">
          <div>
            <label className="primary-label">Name</label>
            <input
              value={data.name}
              name="name"
              onChange={(e) => handleChange(e)}
              placeholder="Enter Name"
              className={`primary-input ${errors["name"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Number</label>
            <input
              value={data.number}
              name="number"
              onChange={(e) => handleChange(e)}
              placeholder="Enter Number"
              className={`primary-input ${errors["number"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Type</label>
            <input
              value={data.type}
              name="type"
              onChange={(e) => handleChange(e)}
              placeholder="Enter Type"
              className={`primary-input ${errors["type"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
          <div>
            <label className="primary-label">Area</label>
            <input
              value={data.area}
              name="area"
              onChange={(e) => handleChange(e)}
              placeholder="Enter Area"
              className={`primary-input ${errors["area"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div className="col-span-2">
            <label className="primary-label">Warehouse</label>
            <Dropdown
              styling="w-full"
              selected={data.warehouse}
              placeholder="Select Warehouse"
              onChange={(value) => {
                const fakeEvent = {
                  target: {
                    name: "warehouse",
                    value: value,
                  },
                };
                handleChange(fakeEvent);
              }}
              options={warehouses.map((warehouse) => ({
                label: warehouse.name,
                value: warehouse.id,
              }))}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-1 mt-4">
          <div>
            <label className="primary-label">Description</label>
            <textarea
              value={data.description}
              name="description"
              onChange={(e) => handleChange(e)}
              placeholder="Enter Description"
              className={`primary-input ${errors["warehouse"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>
        <div className="flex justify-center mt-10">
          <SecondaryButton
            text={loading ? "Adding..." : "Add Location"}
            Icon={FiPlus}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </main>
  );
};

export default AddLocation;
